export enum EcpLocatorRequestUrls {
  ecpLocator = 'ecplocator',
  internetShops = 'internet-shops',
}
